export default function ServiceCTA() {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center space-y-8">
        <h2 className="text-5xl font-bold text-gray-900">
          Ready to Get Started?
        </h2>
        <p className="text-lg text-gray-700 leading-relaxed max-w-2xl mx-auto">
          Our team is here to answer your questions and help you find the perfect care solution for your loved one. Contact us today for a free consultation.
        </p>
        <div className="flex flex-wrap items-center justify-center gap-4">
          <a
            href="/contact"
            className="inline-block bg-orange-500 text-white px-10 py-4 rounded-lg hover:bg-orange-600 transition-all duration-300 text-base font-medium whitespace-nowrap cursor-pointer shadow-lg hover:shadow-xl"
          >
            Contact Us Today
          </a>
          <a
            href="tel:+16105551234"
            className="inline-block bg-[#5C4F8A] text-white px-10 py-4 rounded-lg hover:bg-[#4A3D72] transition-all duration-300 text-base font-medium whitespace-nowrap cursor-pointer shadow-lg hover:shadow-xl"
          >
            <i className="ri-phone-line mr-2"></i>
            Call Now
          </a>
        </div>
        <div className="pt-8 border-t border-gray-200 mt-12">
          <p className="text-sm text-gray-600">
            <strong className="text-gray-900">Office Hours:</strong> Monday - Friday, 8:00 AM - 6:00 PM
          </p>
        </div>
      </div>
    </section>
  );
}
